import { ChainProtocol } from '@archax/shared-types'
import isValidAlgorandAddress from './algorand'
import { isValidAptosAddress } from './aptos'
import isValidEthereumAddress from './evm-address'
import { isValidHederaAddress } from './hedera'
import { isValidSolanaAddress } from './solana'
import { isValidStellarAddress, isValidStellarTokenAddress } from './stellar'
import { isValidXRPLedgerAddress } from './xrpl'

export function isValidAddress(value: string, protocol: ChainProtocol) {
  switch (protocol) {
    case ChainProtocol.Algorand: {
      return isValidAlgorandAddress(value)
    }
    case ChainProtocol.Aptos: {
      return isValidAptosAddress(value)
    }
    case ChainProtocol.Arbitrum:
    case ChainProtocol.Ethereum:
    case ChainProtocol.Etherlink:
    case ChainProtocol.Polygon:
    case ChainProtocol.XDC: {
      return isValidEthereumAddress(value)
    }
    case ChainProtocol.Hedera: {
      return isValidHederaAddress(value)
    }
    case ChainProtocol.Solana: {
      return isValidSolanaAddress(value)
    }
    case ChainProtocol.Stellar: {
      return isValidStellarAddress(value)
    }
    case ChainProtocol.XRP_Ledger: {
      return isValidXRPLedgerAddress(value)
    }
    default:
      throw new Error('Invalid protocol ' + value + '  - ' + protocol)
  }
}

export function isValidTokenAddress(value: string, protocol: ChainProtocol) {
  switch (protocol) {
    case ChainProtocol.Algorand: {
      return isValidAlgorandAddress(value)
    }
    case ChainProtocol.Aptos: {
      return isValidAptosAddress(value)
    }
    case ChainProtocol.Arbitrum:
    case ChainProtocol.Ethereum:
    case ChainProtocol.Etherlink:
    case ChainProtocol.Polygon:
    case ChainProtocol.XDC: {
      return isValidEthereumAddress(value)
    }
    case ChainProtocol.Hedera: {
      return isValidHederaAddress(value)
    }
    case ChainProtocol.Solana: {
      return isValidSolanaAddress(value)
    }
    case ChainProtocol.Stellar: {
      return isValidStellarTokenAddress(value)
    }
    case ChainProtocol.XRP_Ledger: {
      return isValidXRPLedgerAddress(value)
    }
    default:
      throw new Error('Invalid protocol ' + value + ' - ' + protocol)
  }
}
